export default __webpack_public_path__ + "static/media/psmm.51dc8856.png";